__turbopack_context__.v({
  "chevron": "M9udQq_chevron",
  "menu": "M9udQq_menu",
  "open": "M9udQq_open",
  "option": "M9udQq_option",
  "selected": "M9udQq_selected",
  "trigger": "M9udQq_trigger",
  "triggerLabel": "M9udQq_triggerLabel",
  "wrapper": "M9udQq_wrapper",
});
